import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {HttpClient} from '@angular/common/http';
import {Router} from '@angular/router';
import {GridService} from 'app/core-ui/abstract/basegrid/grid.service';
import {ConfigService} from 'app/core-ui/abstract/services/config.service';
import {EventsEmitterService} from 'app/core-ui/abstract/services/emitter.service';
import {LogService} from 'app/core-ui/abstract/services/log.service';
import {catchError, map} from 'rxjs/operators';

@Injectable()
export class AdminTermsAndConditionsService extends GridService {
  constructor(
    http: HttpClient,
    configService: ConfigService,
    eventsEmitterService: EventsEmitterService,
    router: Router,
    logger: LogService,
  ) {
    super(http, configService, eventsEmitterService, router, logger, 'AdminClustersService');
  }

  getTermsAndConditionsList(): Observable<any> {
    let serviceUrl = this.baseUrl + 'TermsAndConditionsService' + '/getAllTermsAndConditions';
    return this.request(serviceUrl).pipe(map(super.extractData), catchError(super.handleError));
  }

  getTermsAndConditionsByTermsCode(termsCode: any): Observable<any> {
    let serviceUrl =
      this.baseUrl +
      'TermsAndConditionsService' +
      '/getTermsAndCondByTermsCode?termsCode=' +
      termsCode;
    return this.request(serviceUrl).pipe(map(super.extractData), catchError(super.handleError));
  }

  deleteTerms(id: any): Observable<any> {
    let serviceUrl =
      this.baseUrl + 'TermsAndConditionsService' + '/deleteTermsAndConditions?termsCode=' + id;
    return this.request(serviceUrl, this.setPostParams(id)).pipe(
      map(super.extractData),
      catchError(super.handleError),
    );
  }

  saveTerms(params: any) {
    let serviceUrl = this.baseUrl + 'TermsAndConditionsService' + '/saveTermsAndConditions';
    return this.request(serviceUrl, this.setPostParams(params)).pipe(
      map(super.extractData),
      catchError(super.handleError),
    );
  }
  checkTerms(id: any) {
    let serviceUrl =
      this.baseUrl + 'TermsAndConditionsService' + '/checkTermByTermsCode?termsCode=' + id;
    return this.request(serviceUrl).pipe(map(super.extractData), catchError(super.handleError));
  }
}
